<template>
  <div id="tab-bar" class="common">
    <ul class="tab-bom" v-if="!$route.path.includes('/login')&&!$route.path.includes('/user/forget')">
      <li style="padding-right: 15%" @click="routerFuc('/home')" :class="{on:$route.path.includes('/home')}"><img src="https://img.deepbaytech.com/fn/logo.png" style=" border: none; height: 34px;"></li>
      <li @click="routerFuc('/home')" :class="{on:$route.path.includes('/home')}">首页</li>
      <li @click="routerFuc('/solution')" :class="{on:$route.path.includes('/solution')}">解决方案</li>
      <!-- <li @click="routerFuc('/news')" :class="{on:$route.path.includes('/news')}">新闻中心</li> -->
      <!--      <li @click="routerFuc('/product')" :class="{on:$route.path.includes('/product')}" >产品中心</li>-->
      <li @click="routerFuc('/cooperation')" :class="{on:$route.path.includes('/cooperation')}">商务合作
      </li>
      <li @click="routerFuc('/about')" :class="{on:$route.path.includes('/about')}">关于我们</li>
      <!-- <div class="login">
        <template v-if="$store.state.mobile">
          <template>
            <el-badge is-dot>
              <i class="el-icon-message " style="font-size:18px;"></i>
            </el-badge>
          </template>
          <div @click="routerFuc('/user')" style="display: inline-block;margin-left: 24px;">
            <el-button style="margin-right: 8px;" size="mini" type="success" icon="el-icon-user-solid" circle></el-button>
            <span>{{$store.state.mobile|hide}}</span>
            <div class="arrow"></div>
          </div>
        </template>
        <template v-else>
          <a class="programme-a" @click="routerFuc('/login')">登录</a>
        </template>
      </div> -->
      <li style="margin-left: 15%">
        <span class="on"></span>
        <span></span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'TabBar',
  data () {
    return {
      show: true,
    }
  },
  methods: {
    routerFuc (path) {
      this.$router.push(path)
    },

  },
  filters: {
    hide (val) {
      return val.substr(0, 3) + '****' + val.substr(7)
    }
  }
}
</script>

<style scoped>
.common {
  min-width: 1180px;
}
#tab-bar {
  position: relative;
  margin: 0;
  padding: 0;
  width: 100%;
  background-color: rgba(255, 255, 255, 1);
  color: #000000;
  z-index: 999;
  font-size: 14px;
}
#tab-bar:hover {
  background-color: rgba(255, 255, 255, 1);
}
.tab-bom {
  width: 100%;
  height: 64px;
  padding: 0;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
.tab-bom > li {
  list-style: none;
  cursor: pointer;
}
.tab-bom > li:hover {
  color: #77ba00;
}
.on {
  color: #77ba00;
}
.el-badge__content.is-fixed.is-dot {
  width: 4px;
  height: 4px;
}
.login {
  position: absolute;
  top: 20px;
  right: 17px;
}
.programme-a {
  display: inline-block;
  width: 62px;
  height: 26px;
  font-size: 14px;
  color: #fff;
  text-align: center;
  line-height: 26px;
  background: #77ba00;
  text-decoration: none;
}
.arrow {
  display: inline-block;
  width: 0;
  height: 0;
  border: 5px solid transparent;
  border-top: 5px solid #666666;
  margin-left: 8px;
  vertical-align: text-bottom;
}
</style>
